module.exports = __webpack_public_path__ + "img/meme_30.9f965fc3.jpg";